var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tarifvergleich',{attrs:{"leistungenMB100":_vm.leistungenMB100,"leistungenMP100":_vm.leistungenMP100}})}
var staticRenderFns = []

export { render, staticRenderFns }